export enum ROLE_ENUM {
    MANAGER = 'ROLE_MANAGER',
    ACTOR = 'ROLE_ACTOR',
    ADMIN = 'ROLE_ADMIN',
}
export enum ROLE_ID_ENUM {
    ACTOR = 1,
    MANAGER = 2,
    ADMIN =3,
}
export enum BOOKING_STATUS {
    ABLE_TO_ORDER= 'ABLE_TO_ORDER',
    WAIT_FOR_APPROVE = 'WAIT_FOR_APPROVE',
    ORDERED = 'ORDERED',
    CANCELLED = 'CANCELLED',
    BLOCKED = 'BLOCKED',
}
export enum BOOKING_STATUS_ID {
    ABLE_TO_ORDER= 1,
    WAIT_FOR_APPROVE = 2,
    ORDERED = 3,
    CANCELLED = 4,
    BLOCKED = 5,
}
export enum ROLE_NAME_ENUM {
    ROLE_MANAGER = 'Менеджер',
    ROLE_ACTOR = 'Сотрудник',
    ROLE_ADMIN = 'Админ',
}
